import axios from "axios";

let client_id = ''
let apiurl = 'https://api.hotgamer.net/api/ga4/purchase'
class ga4event {
    constructor() {
        client_id = localStorage.getItem('ga4_client_id')
    }
    purchase() {
        console.log('ga4 ==== >'+client_id)
        // axios.post(apiurl, {
        //     product: 'annual_vip',
        //     client_id: client_id
        // })
    }
}
export default new ga4event()